import { type ThemeOptions } from "@mui/material/styles";

/**
 * Design System Font Sizes (2025)
 *
 * These are the values from the design system:
 * 2x-small: 11px
 * x-small: 12px
 * small: 14px
 * normal: 16px
 * large: 18px
 * x-large: 24px
 *
 * Mapping to MUI Typography:
 * overline → 2x-small (11px)
 * caption → x-small (12px)
 * body2 → small (14px)
 * body1 → normal (16px)
 * h6 → large (18px)
 * h5 → x-large (24px)
 */

const FONT_FAMILY_SANS = '"Lato", "Segoe UI", -apple-system, BlinkMacSystemFont, sans-serif';
const FONT_FAMILY_SERIF = '"Lora", Georgia, "Times New Roman", serif';

export const muiThemeTypography: ThemeOptions["typography"] = () => ({
  fontFamily: FONT_FAMILY_SANS,
  fontWeightLight: 300,
  fontWeightRegular: 400,
  fontWeightMedium: 400,
  fontWeightSemibold: 700,
  fontWeightBold: 700,
  // 2x-small text
  overline: {
    fontSize: "11px",
    lineHeight: 1.5, // Standard for body text
  },

  // x-small text
  caption: {
    fontSize: "12px",
    lineHeight: 1.5, // Standard for body text
  },

  // Small body text
  body2: {
    fontSize: "14px",
    lineHeight: 1.5, // Standard for body text
  },

  // Primary body text (default)
  body1: {
    fontSize: "16px",
    lineHeight: 1.5, // Standard for body text
  },

  // Heading 6 - large (18px)
  h6: {
    fontFamily: FONT_FAMILY_SERIF,
    fontSize: "18px",
    lineHeight: 1.3, // Tighter for headings
    fontWeight: 500,
  },

  // Heading 5 - x-large (24px)
  h5: {
    fontFamily: FONT_FAMILY_SERIF,
    fontSize: "24px",
    lineHeight: 1.3, // Tighter for headings
    fontWeight: 500,
  },
});
